/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Increase_TimecodeInputs */



/**
* | output |
* | --- |
* | "Increase timecode by 1.001/1.000" |
*
* @param {Increase_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const increase_timecode = /** @type {((inputs?: Increase_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Increase_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Augmenter le timecode de 1,001/1,000")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erhöhen Sie den Timecode um 1,001/1,000.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aumenta il timecode di 1,001/1,000")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличьте временной код на 1.001/1.000")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aumentar el código de tiempo en 1.001/1.000")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码增加 1.001/1.000")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードを1.001/1.000ずつ増やす")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड को 1.001/1.000 से बढ़ाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aumentar o código de tempo em 1,001/1,000")
	return /** @type {LocalizedString} */ ("Increase timecode by 1.001/1.000")
});